<template>
    <div class="tpl-page-container">
        <SideBar></SideBar>
        <MainView></MainView>
    </div>
</template>

<script type="text/javascript">
    import SideBar from '@/components/common_components/side_bar/side_menu.vue'
    import MainView from '@/apps/plan/sub_components/note_publish.vue'
    import {mapActions} from 'vuex'
    import {mapState} from 'vuex'

    export default {
        components: {
            SideBar,
            MainView,
        },
        computed: {
            ...mapState({

            })
        },
        methods: {
            ...mapActions({

            })
        },
        watch: {

        },
        mounted: function () {

        }
    }
</script>
<style type="text/css">
</style>
